<sn-drawer>
  <sn-drawer-header [title]="'map.locations.locationMedia.title' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
  </sn-drawer-header>

  <sn-drawer-content>
    <sn-location-media [location]="location"></sn-location-media>
  </sn-drawer-content>
</sn-drawer>
